'use client';

export default function PageSkeleton() {
  return (
    <div className="animate-pulse w-full min-h-screen bg-white">
      {/* Hero skeleton */}
      <div className="w-full h-64 bg-gray-200 rounded-none" />
      {/* Content area */}
      <div className="container mx-auto px-6 py-12 space-y-10">
        {/* Section title */}
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-64 bg-gray-200 rounded-lg" />
          <div className="h-4 w-96 bg-gray-100 rounded-lg" />
        </div>

        {/* Cards row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(3)]?.map((_, i) => (
            <div key={i} className="rounded-xl border border-gray-100 p-6 space-y-4 shadow-sm">
              <div className="h-12 w-12 bg-gray-200 rounded-full" />
              <div className="h-5 w-3/4 bg-gray-200 rounded" />
              <div className="space-y-2">
                <div className="h-3 w-full bg-gray-100 rounded" />
                <div className="h-3 w-5/6 bg-gray-100 rounded" />
                <div className="h-3 w-4/6 bg-gray-100 rounded" />
              </div>
            </div>
          ))}
        </div>

        {/* Second section */}
        <div className="flex flex-col items-center gap-3 pt-4">
          <div className="h-7 w-48 bg-gray-200 rounded-lg" />
          <div className="h-4 w-80 bg-gray-100 rounded-lg" />
        </div>

        {/* Second cards row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[...Array(4)]?.map((_, i) => (
            <div key={i} className="rounded-xl border border-gray-100 p-5 space-y-3 shadow-sm">
              <div className="h-10 w-10 bg-gray-200 rounded-lg" />
              <div className="h-4 w-2/3 bg-gray-200 rounded" />
              <div className="h-3 w-full bg-gray-100 rounded" />
              <div className="h-3 w-4/5 bg-gray-100 rounded" />
            </div>
          ))}
        </div>

        {/* CTA button skeleton */}
        <div className="flex justify-center pt-2">
          <div className="h-11 w-40 bg-gray-200 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
